<template>
  <div class="empty-state">
    <div v-if="$slots.icon" class="empty-icon">
      <slot name="icon" />
    </div>
    <h3 v-if="title">{{ title }}</h3>
    <p v-if="message">{{ message }}</p>
    <!-- CTA button(s) or extra content -->
    <slot />
  </div>
</template>

<script setup lang="ts">
/**
 * The one "nothing here yet" block (wraps the global .empty-state /
 * .empty-icon classes). Optional #icon slot for a glyph, default slot for a
 * call-to-action.
 */
defineProps<{
  title?: string
  message?: string
}>()
</script>
